import { Section } from 'components/grid/wrappers/FlexWrapper';
import styled from 'styled-components';

export const CenterSection = styled(Section)`
    justify-content: center;
    text-align: center;
`;
